// extracted by mini-css-extract-plugin
module.exports = {"complete":"KcPlaceOrderButton_complete__1OgRT"};